import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const PersonalCard = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M16.0645 19H6.06445C2.06445 19 1.06445 18 1.06445 14V6C1.06445
                2 2.06445 1 6.06445 1H16.0645C20.0645 1 21.0645 2 21.0645 6V14C21.0645 18 20.0645 19 16.0645 19Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.0645 6H18.0645'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.0645 10H18.0645'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.0645 14H18.0645'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.56488 9.28992C8.56452 9.28992 9.37488 8.47956 9.37488 7.47992C9.37488
                6.48029 8.56452 5.66992 7.56488 5.66992C6.56525 5.66992 5.75488 6.48029 5.75488 7.47992C5.75488 8.47956 6.56525 9.28992 7.56488 9.28992Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.0645 14.3298C10.9245 12.8798 9.77445 11.7398 8.32445 11.6098C7.82445
                11.5598 7.31445 11.5598 6.80445 11.6098C5.35445 11.7498 4.20445 12.8798 4.06445 14.3298'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    PersonalCard,
    'personal-card',
);
